(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
/* === Desktop: Hover für Top-Level & Submenus + exakte Overlay-Kanten === */
(function () {
  const desktopHover = () =>
    matchMedia('(min-width: 990px)').matches && matchMedia('(hover: hover)').matches;

  const headerEl = document.querySelector('.header');
  const timers = new WeakMap();

  // Top-Level-ancestor eines <details> finde (Overlay richtet sich daran aus)
  const topOf = (det) => det.closest('.header header-menu > details') || det;

  function setOverlayFor(topDet) {
    if (!headerEl) return;
    const panel = topDet.querySelector('.header__submenu, .mega-menu');
    if (!panel) return;

    const r = panel.getBoundingClientRect();
    const isRight = !!topDet.closest('.header__right-inline');

    // NEU: Wir liefern die px-Werte direkt mit ±50px als Variablen an CSS
    // LINKS (#1–3): Overlay-Ende = rechte Panelkante + 50
    document.documentElement.style.setProperty('--overlay-left-end',  (r.right + 50) + 'px');
    // RECHTS (#4–5): Overlay-Start = linke Panelkante - 50 (mindestens 0)
    const startRight = Math.max(0, Math.round(r.left - 50));
    document.documentElement.style.setProperty('--overlay-right-start', startRight + 'px');

    headerEl.classList.add('overlay-visible');
    headerEl.classList.toggle('overlay-right', isRight);
    headerEl.classList.toggle('overlay-left',  !isRight);
  }

  function clearOverlay() {
    headerEl?.classList.remove('overlay-visible','overlay-left','overlay-right');
  }

  function openDet(det) {
  clearTimeout(timers.get(det));
  const topDet = topOf(det);
  const isRight = !!topDet.closest('.header__right-inline');
  
  headerEl.classList.add('overlay-visible');
  headerEl.classList.toggle('overlay-right', isRight);
  headerEl.classList.toggle('overlay-left', !isRight);
  
  if (isRight) {
    document.documentElement.style.setProperty('--overlay-right-start', '0px');
  } else {
    document.documentElement.style.setProperty('--overlay-left-end', '100vw');
  }

  det.setAttribute('open','');

  // Double RAF ensures layout is complete
  requestAnimationFrame(() => {
    requestAnimationFrame(() => setOverlayFor(topDet));
  });

  const panel = topDet.querySelector('.header__submenu, .mega-menu');
  if (panel && !panel.__recalc) {
    panel.__recalc = true;
    ['mouseenter','mousemove','transitionend'].forEach(ev =>
      panel.addEventListener(ev, () => desktopHover() && topDet.hasAttribute('open') && setOverlayFor(topDet))
    );
  }
}


  function closeDet(det) {
    const t = setTimeout(() => {
      det.removeAttribute('open');
      if (!document.querySelector('.header header-menu > details[open]')) clearOverlay();
    }, 120);
    timers.set(det, t);
  }

  function bindHover() {
    // Alle <details> (Top + Submenus) hovern
    document.querySelectorAll('.header header-menu details').forEach((det) => {
      if (det.__bound) return; det.__bound = true;
      det.addEventListener('mouseenter', () => desktopHover() && openDet(det));
      det.addEventListener('mouseleave', () => desktopHover() && closeDet(det));
    });

    // Click-Toggling auf Desktop deaktivieren (Top + Submenus)
    document.querySelectorAll('.header header-menu details > summary').forEach((s) => {
      if (s.__noclick) return; s.__noclick = true;
      s.addEventListener('click', (e) => desktopHover() && e.preventDefault());
    });
  }

  document.addEventListener('DOMContentLoaded', bindHover);
  document.addEventListener('shopify:section:load', bindHover);
  document.addEventListener('shopify:section:select', bindHover);

  // Overlay bei Klick außerhalb schließen
  document.addEventListener('click', (e) => {
    if (!desktopHover() || !headerEl?.classList.contains('overlay-visible')) return;
    if (!e.target.closest('.header header-menu')) {
      document.querySelectorAll('.header header-menu details[open]').forEach(d => d.removeAttribute('open'));
      clearOverlay();
    }
  });

  // Recalc bei Resize (falls offen)
  addEventListener('resize', () => {
    if (!desktopHover()) return clearOverlay();
    const openTop = document.querySelector('.header header-menu > details[open]');
    if (openTop) setOverlayFor(openTop);
  });
})();






  } catch(e) { console.error(e); }
})();
})();
